/* Just Plywood — postcode delivery-rate lookup.  jp:zones v5 · 2026-11-04 (Geelong/Bellarine/Torquay 3212-3228 added to Zone 3; Zone 4 rate $259 and 3358 added; 3723 removed from Zone 2)
   Victoria only. One yard: 2 Graystone Ct, Epping VIC 3076.

   ZONE DATA LIVES IN FOUR PLACES — change them together (see CLAUDE.md rule 4):
     1. this file (ZONES below)                     — the lookup engine
     2. templates/page.delivery.json  jp_zone_tables > region_vic > rows
     3. templates/page.delivery.json  image_with_text_fAXTPb (Zone 1 + Zone 2 lists)
     4. templates/page.delivery.json  image_with_text_BcMpKB (Zone 3 + Zone 4 lists)
   Plus two derived echoes: index.json jp_delivery_band.note, and the hardcoded
   example figures in sections/jp-postcode-checker.liquid.
   Checkout prices come from the Postcode Shipping app (regions Zone 1-4) and Google
   Shopping from Merchant Center policy "JP Postcode Zones" — keep both in step too.

   THE LISTS ARE DISJOINT — every postcode appears in exactly one zone. The client's
   original lists overlapped (Z1 n Z2 = 15, Z2 n Z3 = 5); on 2026-07-21 they resolved
   those by deleting each duplicate from the CHEAPER zone, so an overlapping postcode
   is now charged the DEARER rate. findZone() still returns the first match, but with
   disjoint lists the order no longer affects pricing. tools/verify-zones.mjs asserts
   the disjointness — if a postcode ever lands in two zones again, decide the rule
   explicitly rather than letting list order silently price it.

   Membership lists, NOT numeric ranges — these zones are discrete and a range
   silently over-covers (the retired VIC predicate tested 3000-3207 and so claimed
   208 postcodes). `count` is asserted at load; a bad paste warns in the console. */
(function () {
  'use strict';

  var DISPATCH = '2–5 business days';
  var METHOD = 'Just Plywood crane truck';
  var PICKUP = 'Epping VIC';

  var ZONES = [
    {
      n: 1, zone: 'Epping Local', rate: 89, count: 3, codes:
      '3076 3752 3757'
    },
    {
      n: 2, zone: 'Melbourne Metro', rate: 119, count: 194, codes:
      '3000 3001 3002 3003 3004 3005 3006 3008 3010 3011 3012 3013 3015 3016 3018 ' +
      '3019 3020 3021 3022 3023 3024 3025 3026 3027 3028 3031 3032 3033 3034 3036 ' +
      '3037 3038 3039 3040 3041 3042 3043 3044 3045 3046 3047 3048 3049 3050 3051 ' +
      '3052 3053 3054 3055 3056 3057 3058 3059 3060 3061 3062 3064 3065 3066 3067 ' +
      '3068 3070 3071 3072 3073 3074 3075 3078 3079 3081 3082 3083 3084 3085 3086 ' +
      '3087 3088 3089 3090 3091 3093 3094 3095 3096 3097 3099 3101 3102 3103 3104 ' +
      '3105 3106 3107 3108 3109 3111 3113 3114 3115 3121 3122 3123 3124 3125 3126 ' +
      '3127 3128 3129 3130 3131 3132 3133 3134 3135 3136 3137 3138 3141 3142 3143 ' +
      '3144 3145 3146 3147 3148 3149 3150 3151 3152 3153 3154 3155 3161 3162 3163 ' +
      '3164 3165 3166 3167 3168 3169 3170 3171 3172 3173 3174 3175 3176 3177 3178 ' +
      '3179 3180 3181 3182 3183 3184 3185 3186 3187 3188 3189 3190 3191 3192 3193 ' +
      '3194 3195 3196 3197 3198 3200 3201 3202 3204 3205 3206 3207 3335 3336 3337 ' +
      '3338 3340 3427 3750 3753 3754 3755 3756 3805 3806 3910 3911 3975 3978'
    },
    {
      n: 3, zone: 'Greater Melbourne', rate: 159, count: 42, codes:
      '3029 3030 3140 3160 3199 3211 3212 3213 3214 3215 3216 3217 3218 3219 3220 ' +
      '3221 3222 3223 3224 3225 3226 3227 3228 3429 3434 3437 3440 3775 3777 3782 ' +
      '3783 3799 3809 3810 3818 3820 3930 3931 3939 3941 3943 3944'
    },
    {
      n: 4, zone: 'Ballarat & Bendigo', rate: 259, count: 16, codes:
      '3350 3351 3352 3353 3354 3355 3356 3357 3358 3550 3551 3552 3553 3554 3555 3556'
    }
  ];

  /* Accepts whitespace/comma separated 4-digit codes, and NNNN-NNNN ranges. */
  function expand(spec) {
    var set = {}, tokens = String(spec).split(/[\s,]+/), i, parts, a, b;
    for (i = 0; i < tokens.length; i++) {
      if (!tokens[i]) continue;
      parts = tokens[i].split('-');
      if (parts.length === 2) {
        for (a = +parts[0], b = +parts[1]; a <= b; a++) set[a] = 1;
      } else {
        set[+tokens[i]] = 1;
      }
    }
    return set;
  }

  (function buildZones() {
    for (var i = 0; i < ZONES.length; i++) {
      var z = ZONES[i];
      z.set = expand(z.codes);
      var parsed = 0, k;
      for (k in z.set) if (Object.prototype.hasOwnProperty.call(z.set, k)) parsed++;
      if (parsed !== z.count && window.console && console.warn) {
        console.warn('[jp-postcode] Zone ' + z.n + ' (' + z.zone + '): expected ' +
          z.count + ' postcodes, parsed ' + parsed);
      }
    }
  })();

  function findZone(n) {
    for (var i = 0; i < ZONES.length; i++) if (ZONES[i].set[n] === 1) return ZONES[i];
    return null;
  }

  function lookup(pc) {
    pc = (pc || '').trim();
    if (!/^\d{4}$/.test(pc)) return { ok: false, postcode: pc };
    var z = findZone(+pc);
    if (!z) return { ok: false, postcode: pc };
    return {
      ok: true, postcode: pc, zoneNumber: z.n, zone: z.zone, rate: z.rate,
      disp: DISPATCH, method: METHOD, pickup: PICKUP
    };
  }

  window.JPPostcode = { lookup: lookup };

  /* Inline result line (homepage band):
     <form data-jp-postcode-inline><input><button></button><div data-jp-result hidden></div></form> */
  function bindInline(form) {
    var input = form.querySelector('input');
    /* result may sit inside the form or as a following sibling (design order:
       input -> note -> result) */
    var result = form.querySelector('[data-jp-result]') ||
      (form.parentNode && form.parentNode.querySelector('[data-jp-result]'));
    if (!input || !result) return;
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 4);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input.value) return;
      var r = lookup(input.value);
      result.hidden = false;
      if (r.ok) {
        result.textContent = '✓ ' + r.postcode + ' · ' + r.zone + ' — $' + r.rate + ' flat, dispatch ' + r.disp;
      } else {
        result.textContent = 'We don’t deliver to ' + r.postcode + ' on our own trucks — call (03) 8339 2252 or pick up free from Epping.';
      }
      try { localStorage.setItem('jp-postcode', input.value); } catch (err) {}
    });
    try {
      var saved = localStorage.getItem('jp-postcode');
      if (saved && !input.value) input.value = saved;
    } catch (err) {}
  }

  /* Full result card (delivery page): elements carry data-jp-del-* hooks */
  function bindCard(root) {
    var input = root.querySelector('[data-jp-del-input]');
    var found = root.querySelector('[data-jp-del-found]');
    var notFound = root.querySelector('[data-jp-del-notfound]');
    if (!input) return;

    function set(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }
    /* Map: a single pin on the customer's suburb once we have a valid postcode,
       otherwise a single pin on the Epping yard. Deliberately NOT the directions
       embed — it renders drive-time labels ("30 min · 34.9 km") that sit directly
       under "Dispatch 2–5 business days" and read as a delivery window. Same
       keyless maps.google.com endpoint the card has always used, so no CSP change.
       The "Pickup yard" row and the directions link still point at Epping. */
    function renderMap(r) {
      var map = root.querySelector('[data-jp-del-map]');
      if (!map) return;
      var name = map.getAttribute('data-yard-name') || r.pickup;
      var addr = map.getAttribute('data-yard-address');
      var dir = map.getAttribute('data-yard-directions');
      if (!addr) { map.hidden = true; return; }
      set('[data-jp-del-store]', name);
      var frame = map.querySelector('[data-jp-del-mapframe]');
      if (frame) {
        var hasPostcode = r.postcode && /^\d{4}$/.test(r.postcode);
        var src = hasPostcode
          ? 'https://maps.google.com/maps?q=' + encodeURIComponent(r.postcode + ' VIC, Australia') + '&z=12&output=embed'
          : 'https://maps.google.com/maps?q=' + encodeURIComponent('Just Plywood, ' + addr) + '&z=13&output=embed';
        var iframe = frame.querySelector('iframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.setAttribute('loading', 'lazy');
          iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
          frame.appendChild(iframe);
        }
        iframe.setAttribute('title', hasPostcode
          ? 'Map of delivery postcode ' + r.postcode
          : 'Map of our ' + name + ' yard');
        if (iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
      }
      var dirEl = map.querySelector('[data-jp-del-directions]');
      if (dirEl) dirEl.href = dir || 'https://maps.google.com/?q=' + encodeURIComponent('Just Plywood, ' + addr);
      map.hidden = false;
    }
    function render(r) {
      if (!found || !notFound) return;
      if (r.ok) {
        found.hidden = false;
        notFound.hidden = true;
        set('[data-jp-del-tag]', 'Result · ' + r.postcode + ' · Zone ' + r.zoneNumber);
        set('[data-jp-del-zonename]', r.zone);
        set('[data-jp-del-rate]', '$' + r.rate);
        set('[data-jp-del-disp]', r.disp);
        set('[data-jp-del-method]', r.method);
        set('[data-jp-del-pickup]', r.pickup);
        renderMap(r);
      } else {
        found.hidden = true;
        notFound.hidden = false;
        set('[data-jp-del-badpc]', r.postcode);
      }
      try { localStorage.setItem('jp-postcode', input.value); } catch (err) {}
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 4);
    });

    var form = input.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!input.value) return;
        render(lookup(input.value));
      });
    }
    root.querySelectorAll('[data-jp-del-quick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.getAttribute('data-jp-del-quick');
        render(lookup(input.value));
      });
    });

    /* Only restore a saved postcode if it STILL resolves — otherwise a returning
       visitor holding a retired (QLD or regional VIC) postcode gets the negative
       panel painted before they have interacted with anything. */
    try {
      var saved = localStorage.getItem('jp-postcode');
      if (saved) {
        var restored = lookup(saved);
        if (restored.ok) {
          input.value = saved;
          render(restored);
        }
      }
    } catch (err) {}
  }

  function init() {
    document.querySelectorAll('[data-jp-postcode-inline]').forEach(bindInline);
    document.querySelectorAll('[data-jp-postcode-card]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
